import constants from '@/common/constants';

import store from '@/store';

const getProfile = () => (store.state as any)?.auth?.oidc?.profile;

export const getUserRoleId = (): number | undefined => getProfile()?.roleIds?.[0];

export const getUserRegionsRfIds = () => {
  const userRole = getUserRoleId();
  const isSubjectRfRole = userRole === constants.USER_ROLE_ID.subjectRF;
  const userRegionRfIds = getProfile()?.employee?.regionRfIds ?? [];
  return { isSubjectRfRole, userRegionRfIds };
};
